import React from 'react'
import { css } from '@emotion/css'
import { IconAi } from '@contrast-security-inc/design-system-foundations'
import {
  logo_dotnet,
  logo_dotnetcore,
  logo_go,
  logo_java,
  logo_kotlin,
  logo_node,
  logo_php,
  logo_python,
  logo_ruby,
  logo_scala
} from '../images'

export const OPERATING_SYSTEM = {
  KEY: 'operating-system',
  LINUX: 'linux',
  WINDOWS: 'windows',
  MACOS: 'macos'
}

export interface LanguageInfo {
  type: string
  titleMsg: string
  logo: string
  doclink: string
  defaultBranches?: string[][]
  learnMorePath: string
  priorVersion?: string
  agentId: string
  uiText: string
}
export const languageInfo: LanguageInfo[] = [
  {
    type: 'UNIVERSAL',
    titleMsg: 'title_language_universal',
    logo: <IconAi size="lg" color="teal70" />,
    doclink: 'get-started-agent-installation.html',
    defaultBranches: [[OPERATING_SYSTEM.KEY, OPERATING_SYSTEM.LINUX]],
    learnMorePath: 'get-started-agent-installation.html',
    priorVersion: 'na',
    agentId: 'Universal',
    uiText: 'Universal'
  },
  {
    type: 'JAVA',
    titleMsg: 'title_language_java',
    logo: logo_java,
    doclink: 'install-the-java-agent.html',
    learnMorePath: 'java-supported-technologies.html',
    priorVersion: '6.10.1',
    agentId: 'java',
    uiText: 'Java'
  },
  {
    type: 'KOTLIN',
    titleMsg: 'title_language_kotlin',
    logo: logo_kotlin,
    doclink: 'install-the-java-agent.html',
    learnMorePath: 'java-supported-technologies.html',
    agentId: 'kotlin',
    uiText: 'Kotlin'
  },
  {
    type: 'SCALA',
    titleMsg: 'title_language_scala',
    logo: logo_scala,
    doclink: 'install-the-java-agent.html',
    learnMorePath: 'java-supported-technologies.html',
    agentId: 'scala',
    uiText: 'Scala'
  },
  // all of above codes as java
  {
    type: 'DOTNET',
    titleMsg: 'title_language_dotnet',
    logo: logo_dotnet,
    doclink: 'install--net-framework.html',
    defaultBranches: [[OPERATING_SYSTEM.KEY, OPERATING_SYSTEM.WINDOWS]],
    learnMorePath: '-net-framework-supported-technologies.html',
    priorVersion: '51.0.40',
    agentId: 'dotnet',
    uiText: '.NET Framework'
  },
  {
    type: 'DOTNET_CORE',
    titleMsg: 'title_language_dotnetcore',
    logo: logo_dotnetcore,
    doclink: 'install--net-core.html',
    defaultBranches: [[OPERATING_SYSTEM.KEY, OPERATING_SYSTEM.WINDOWS]],
    learnMorePath: '-net-core-supported-technologies.html',
    priorVersion: '4.2.22',
    agentId: 'dotnet-core',
    uiText: '.NET Core'
  },
  {
    type: 'NODE',
    titleMsg: 'title_language_node',
    logo: logo_node,
    doclink: 'install-node-js.html',
    learnMorePath: 'node-js-supported-technologies.html',
    priorVersion: '5.15.0',
    agentId: 'node',
    uiText: 'Node'
  },
  {
    type: 'RUBY',
    titleMsg: 'title_language_ruby',
    logo: logo_ruby,
    doclink: 'install-ruby.html',
    learnMorePath: 'ruby-supported-technologies.html',
    agentId: 'ruby',
    uiText: 'Ruby'
  },
  {
    type: 'PYTHON',
    titleMsg: 'title_language_python',
    logo: logo_python,
    doclink: 'install-python.html',
    learnMorePath: 'python-supported-technologies.html',
    defaultBranches: [[OPERATING_SYSTEM.KEY, OPERATING_SYSTEM.LINUX]],
    priorVersion: '8.6.0',
    agentId: 'python',
    uiText: 'Python'
  },
  {
    type: 'PHP',
    titleMsg: 'title_language_php',
    logo: logo_php,
    doclink: 'install-php.html',
    learnMorePath: 'php-supported-technologies.html',
    defaultBranches: [[OPERATING_SYSTEM.KEY, OPERATING_SYSTEM.LINUX]],
    priorVersion: '1.34.0',
    agentId: 'php',
    uiText: 'PHP'
  },
  {
    type: 'GO',
    titleMsg: 'title_language_go',
    logo: logo_go,
    doclink: 'install-go-agent-with-contrast-go-installer.html',
    learnMorePath: 'go-supported-technologies.html',
    defaultBranches: [[OPERATING_SYSTEM.KEY, OPERATING_SYSTEM.LINUX]],
    priorVersion: '6.11.0',
    agentId: 'go',
    uiText: 'GO'
  }
]

export const TYPING_DEBOUNCE_MS = 250

export const cardCss = css`
  display: flex;
  align-items: center;
  width: 50%;
  height: 32px;
`
